import styled from "styled-components";

import { getSpacing } from "@braze/beacon-styling";

export const StyledForm = styled.form`
  margin-bottom: ${getSpacing("none")};
`;
